const PercentageScaleIllustration = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width='160'
      height='161'
      fill='none'
      aria-hidden='true'
      focusable='false'
    >
      <mask
        id='a'
        width='129'
        height='122'
        x='15'
        y='18'
        maskUnits='userSpaceOnUse'
        style={{ maskType: 'alpha' }}
      >
        <path
          fill='#C4C4C4'
          fillRule='evenodd'
          d='M143.999 18h-128v105h22.158C48.965 133.519 63.726 139.998 80 139.998c16.274 0 31.035-6.479 41.843-16.998h22.156V18Z'
          clipRule='evenodd'
        />
      </mask>
      <g mask='url(#a)'>
        <circle
          cx='80'
          cy='80.498'
          r='60'
          fill='#1A1A1A'
          fillOpacity='.08'
        />
        <path
          fill='#B5B5B5'
          fillRule='evenodd'
          d='m21.998 115.859 1.627 7.601 57.32-13.963-23.723 31h47.26l-23.537-31 63.053-14.398-1.626-7.602L21.998 115.86Z'
          clipRule='evenodd'
        />
        <path
          fill='#FF620F'
          fillRule='evenodd'
          d='M141.372 69.548c0 14.353-11.635 25.988-25.987 25.988-14.353 0-25.989-11.635-25.989-25.988 0-14.352 11.636-25.987 25.989-25.987 14.352 0 25.987 11.635 25.987 25.987Z'
          clipRule='evenodd'
        />
        <mask
          id='b'
          width='67'
          height='97'
          x='15'
          y='18'
          maskUnits='userSpaceOnUse'
          style={{ maskType: 'alpha' }}
        >
          <path
            fill='#fff'
            d='M15.999 18.498H81.2v95.899H16V18.499Z'
          />
        </mask>
        <g mask='url(#b)'>
          <path
            fill='#FF620F'
            fillRule='evenodd'
            d='M44.395 114.397 16 101.86l36.805-83.362L81.2 31.035l-36.805 83.362Z'
            clipRule='evenodd'
          />
        </g>
      </g>
    </svg>
  );
};

export default PercentageScaleIllustration;
